import React, { Fragment, useEffect, useState } from 'react';
import css from './WorkersCard.module.css';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';
import { ReactComponent as GoToArrow } from '../../assets/svg/ArrowRight.svg';
import { ReactComponent as BlankProfileImg } from '../../assets/svg/Blank_Profile.svg';

import GoToButton from '../GoToButton/GoToButton';
import NamedLink from '../NamedLink/NamedLink';
import { createSlug } from '../../util/urlHelpers';
import moment from 'moment';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { FormattedMessage, injectIntl } from 'react-intl';
import { findOptionsForSelectFilter } from '../../util/search';
import config from '../../config';
import { languageSelectOptions, listingTypes } from '../../marketplace-custom-config';
import classNames from 'classnames';
import { isArray, isEmpty } from 'lodash';
import Button, { InlineTextButton } from '../Button/Button';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  acceptAppliedJob,
  declineAppliedJob,
  setListingVacancyFullStatus,
  setWorkerBlockedTimeslotStatus,
} from './workerCard.duck';
import { ReactComponent as Star } from '../../assets/svg/star.svg';
import { updateProfile } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck';
import { ReactComponent as VerifiedTickComponent } from '../../assets/svg/verifiedBatch.svg';
import axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import {
  TRANSITION_ACCEPT_ASSIGNED_GIG,
  TRANSITION_AUTO_CONFIRM_ASSIGNED_GIG,
  TRANSITION_BUSINESS_MARK_DISPUTE,
  TRANSITION_BUSINESS_NO_RESPONSE,
  TRANSITION_CHECK_PAYOUT_STATUS,
  TRANSITION_CHECK_PAYOUT_STATUS_FOR_COMPLETION,
  TRANSITION_COMPLETE,
  TRANSITION_COMPLETE_WORKER_PAYOUT,
  TRANSITION_CONFIRM_AND_COMPLETE_TRANSACTION,
  TRANSITION_GIG_START_NOTIF_BEFORE_1,
  TRANSITION_GIG_START_NOTIF_BEFORE_24,
  TRANSITION_INITIATE_BUSINESS_REFUND,
  TRANSITION_INITIATE_PARTIAL_REFUND,
  TRANSITION_INITIATE_WORKER_PAYOUT,
  TRANSITION_MARKED_DONE_BY_BUSINESS,
  TRANSITION_PROVIDER_CANCEL,
  TRANSITION_PROVIDER_CANCEL_BEFORE_START_1,
  TRANSITION_PROVIDER_CANCEL_BEFORE_START_24,
  TRANSITION_REINITIATE_BUSINESS_REFUND_ON_FAILURE,
  TRANSITION_REINITIATE_PAYOUT_ON_FAILURE,
  TRANSITION_RESOLVE_DISPUTE,
  TRANSITION_STARTING_JOB,
  TRANSITION_WORKER_CANCEL,
  TRANSITION_WORKER_CANCEL_BEFORE_ACCEPT,
  TRANSITION_WORKER_CANCEL_BEFORE_START_1,
  TRANSITION_WORKER_CANCEL_BEFORE_START_24,
  TRANSITION_ZERO_CONFIRM_PAYMENT,
  TRANSITION_ZERO_DECLINE_PAYMENT,
  TRANSITION_ZERO_REQUEST_PAYMENT,
} from '../../util/transaction';
import { constructTimesArray } from '../../util/workerTimeslotBlockChecker';

const cancelTransactions = new Set([
  TRANSITION_WORKER_CANCEL,
  TRANSITION_WORKER_CANCEL_BEFORE_ACCEPT,
  TRANSITION_WORKER_CANCEL_BEFORE_START_1,
  TRANSITION_WORKER_CANCEL_BEFORE_START_24,
]);

const acceptedTransactions = new Set([
  TRANSITION_ZERO_CONFIRM_PAYMENT,
  TRANSITION_ACCEPT_ASSIGNED_GIG,
  TRANSITION_AUTO_CONFIRM_ASSIGNED_GIG,
  TRANSITION_GIG_START_NOTIF_BEFORE_1,
  TRANSITION_GIG_START_NOTIF_BEFORE_24,
  TRANSITION_STARTING_JOB,
  TRANSITION_COMPLETE,
  TRANSITION_BUSINESS_MARK_DISPUTE,
  TRANSITION_BUSINESS_NO_RESPONSE,
  TRANSITION_MARKED_DONE_BY_BUSINESS,
  TRANSITION_RESOLVE_DISPUTE,
  TRANSITION_INITIATE_WORKER_PAYOUT,
  TRANSITION_INITIATE_BUSINESS_REFUND,
  TRANSITION_INITIATE_PARTIAL_REFUND,
  TRANSITION_CONFIRM_AND_COMPLETE_TRANSACTION,
  TRANSITION_CHECK_PAYOUT_STATUS,
  TRANSITION_COMPLETE_WORKER_PAYOUT,
  TRANSITION_REINITIATE_PAYOUT_ON_FAILURE,
  TRANSITION_CHECK_PAYOUT_STATUS_FOR_COMPLETION,
  TRANSITION_REINITIATE_BUSINESS_REFUND_ON_FAILURE,
  TRANSITION_PROVIDER_CANCEL_BEFORE_START_1,
  TRANSITION_PROVIDER_CANCEL,
  TRANSITION_PROVIDER_CANCEL_BEFORE_START_24,
]);

function WorkersCardComponent(props) {
  const {
    workerDetails,
    workerProfileImages,
    userNativeLang,
    history,
    from,
    onAcceptAppliedJob,
    onDeclineAppliedJob,
    txId,
    listingId,
    acceptAppliedJobInProgress,
    acceptAppliedJobSuccess,
    acceptAppliedJobError,
    declineAppliedJobInProgress,
    declineAppliedJobSuccess,
    declineAppliedJobError,
    tab,
    txLastTransition: propsTxLastTransition = '',
    onSucessHandler,
    listing,
    isWorkerTimeslotBlocked,
    isListingVacancyFull,
    onSetWorkerBlockedTimeslotStatus,
    onSetListingVacancyFullStatus,
    intl,
    canceledAt,
  } = props;
  const [rating, setRating] = useState(0);
  const [gigCount, setGigCount] = useState(0);
  const [txLastTransition, setTxLastTransition] = useState(propsTxLastTransition);
  //for business profile
  const isProvider = workerDetails?.attributes?.profile?.publicData?.isProvider;

  const workerName =
    from === 'ListingApplied' ||
    !(workerDetails?.attributes?.profile?.firstName && workerDetails?.attributes?.profile?.lastName)
      ? `${workerDetails?.attributes?.profile?.displayName}`
      : `${workerDetails?.attributes?.profile?.firstName} ${workerDetails?.attributes?.profile?.lastName}`;

  const isProfileVerified =
    workerDetails?.attributes?.profile?.metadata?.isProfileVerified || false;
  const workerId = workerDetails?.relationships?.profileImage?.data?.id?.uuid;

  const matchedProfileImage =
    !isEmpty(workerProfileImages) &&
    isArray(workerProfileImages) &&
    workerProfileImages?.find(i => i?.id?.uuid === workerId);
  const profileImageUrl =
    workerDetails?.profileImage?.attributes?.variants?.default?.url ||
    matchedProfileImage?.attributes?.variants?.default?.url;
  const id = workerDetails?.id?.uuid;
  const slug = createSlug(workerName);
  //total year of job experience calculation

  const jobStartDates = workerDetails?.attributes?.profile?.publicData?.jobExperiences?.map(
    m => m?.jobStartDate
  );

  const jobEndDates = workerDetails?.attributes?.profile?.publicData?.jobExperiences?.map(
    m => m?.jobEndDate
  );

  const momentJobStartDate = jobStartDates && moment(jobStartDates).locale(userNativeLang);
  const momentJobEndDate = jobEndDates && moment(jobEndDates).locale(userNativeLang);

  const differenceInYears = jobStartDates?.map((date, indx) => {
    const yearsWorkedTillNow = momentJobEndDate
      ? moment(jobEndDates[indx]).diff(jobStartDates[indx], 'years')
      : moment().diff(jobStartDates, 'years');

    return yearsWorkedTillNow;
  });

  const totalYearsWorkedTillNow =
    differenceInYears?.length > 0
      ? differenceInYears?.reduce((a, b) => {
          return a + b;
        })
      : null;

  //reference count
  const referenceCount = workerDetails?.attributes?.profile?.publicData?.references?.length;

  //company industry type
  const industryType = isProvider && workerDetails?.attributes?.profile?.publicData?.industryType;
  const filterConfig = config.custom.filters;

  const companyIndustry = industryType
    ? Object.values(listingTypes).find(f => f.value === industryType)?.label[userNativeLang]
    : undefined;

  const companyName = isProvider && workerDetails?.attributes?.profile?.publicData?.companyName;
  const sep = userNativeLang === languageSelectOptions.fr.value ? 'à' : 'at';
  const cancelDateStr = canceledAt
    ? `${moment(canceledAt).format('DD MMM, YYYY')} ${sep} ${moment(canceledAt).format('HH[h]mm')}`
    : '';

  const listingTimeslots = constructTimesArray(listing);
  const closeModal = e => {
    e.preventDefault();
    if (isWorkerTimeslotBlocked) {
      onSetWorkerBlockedTimeslotStatus(false);
    } else if (isListingVacancyFull) {
      onSetListingVacancyFullStatus(false);
    }
  };
  useEffect(() => {
    if (workerDetails?.id?.uuid) {
      const reviewParams = isProvider
        ? { businessId: workerDetails?.id?.uuid, to: 'business' }
        : { workerId: workerDetails?.id?.uuid, to: 'worker' };
      const gigCountParams = { userId: workerDetails?.id?.uuid, isProvider };
      Promise.all([
        axios.post(`${apiBaseUrl()}/api/reviews/get-total-rating`, reviewParams).then(res => {
          setRating(res.data);
        }),
        axios.post(`${apiBaseUrl()}/api/user/getGigCount`, gigCountParams).then(res => {
          setGigCount(res.data.gigCount);
        }),
      ]);
    }
  }, []);

  useEffect(() => {
    setTxLastTransition(propsTxLastTransition);
  }, [propsTxLastTransition]);

  return (
    <Fragment key={workerDetails?.id?.uuid}>
      {/* for business profile card in admin dashboard */}
      {!!isProvider ? (
        <div
          className={css.workerDetailCard}
          onClick={() => {
            const params = { id: id, slug: slug };

            history.push(
              createResourceLocatorString(
                'BusinessProfileAdminViewPage',
                routeConfiguration(),
                params,
                {}
              )
            );
          }}
        >
          <div>
            {/* <AvatarLarge className={css.avatar} user={workerDetails} disableProfileLink /> */}

            {profileImageUrl ? (
              <>
                <img src={profileImageUrl} alt={workerName} className={css.profileImg} />
              </>
            ) : (
              <BlankProfileImg className={css.profileImg} />
            )}
          </div>
          <div className={css.dataDiv}>
            <div className={css.topBottomRow}>
              <span>{companyName}</span>
            </div>
            {!!industryType ? <span className={css.yrOfExp}>{companyIndustry}</span> : null}
            <span className={css.refCount}>
              <FormattedMessage id="AdminBusinessPage.responsiblePerson" />
              {workerName}{' '}
            </span>

            <div className={css.bottomRow}>
              <span>
                {gigCount} {intl.formatMessage({ id: 'WorkersCard.gigs' })}
              </span>
              {/* {id && (
                <NamedLink name="ProfilePage" params={{ id, slug }} className={css.goToProfile}> */}
              <GoToButton onClick />
              {/* </NamedLink>
              )} */}
            </div>
          </div>
        </div>
      ) : (
        <div
          className={classNames(css.workerDetailCard, css.aplliedWorkerDetail)}
          onClick={() => {
            const params = { id: id, slug: slug };

            from === 'BusinessDashboard' || from === 'ListingApplied'
              ? history.push(
                  createResourceLocatorString(
                    'WorkerProfileBusinessViewPage',
                    routeConfiguration(),
                    params,
                    {}
                  ),
                  { from: from }
                )
              : history.push(
                  createResourceLocatorString(
                    'WorkerProfileAdminViewPage',
                    routeConfiguration(),
                    params,
                    { tab }
                  )
                );
          }}
        >
          <div className={css.workerDetailDiv}>
            <div>
              {profileImageUrl ? (
                <img src={profileImageUrl} alt={workerName} className={css.profileImg} />
              ) : (
                <BlankProfileImg className={css.profileImg} />
              )}
            </div>
            <div className={css.dataDiv}>
              <div className={css.topBottomRow}>
                <span className={css.nameRow}>
                  <div className={css.workrName}>{workerName}</div>

                  {isProfileVerified && <VerifiedTickComponent />}
                </span>
                {canceledAt ? (
                  <span className={css.listingCanclled}>
                    <FormattedMessage
                      id="WorkerCard.listingClose"
                      values={{ date: cancelDateStr }}
                    />
                  </span>
                ) : null}

                <div>
                  <Star />

                  <span>{rating}</span>
                </div>
              </div>

              {totalYearsWorkedTillNow ? (
                <span className={css.yrOfExp}>
                  {totalYearsWorkedTillNow} {intl.formatMessage({ id: 'WorkersCard.yearsOfExp' })}
                </span>
              ) : null}

              {from === 'ListingApplied' ? null : (
                <>
                  {referenceCount ? (
                    <span className={css.refCount}>
                      {referenceCount} {intl.formatMessage({ id: 'WorkersCard.ref' })}
                    </span>
                  ) : null}

                  <div className={css.bottomRow}>
                    <span>
                      {gigCount} {intl.formatMessage({ id: 'WorkersCard.gigs' })}
                    </span>
                    {/* {id && (
                      <NamedLink
                        name="ProfilePage"
                        params={{ id, slug }}
                        className={css.goToProfile}
                      > */}
                    <GoToButton onClick />
                    {/* </NamedLink> */}
                    {/* )} */}
                  </div>
                </>
              )}
            </div>
          </div>

          {from === 'ListingApplied' ? (
            cancelTransactions.has(txLastTransition) ? (
              <>
                <span className={css.hDivider} />

                {/* when worker is not accepted */}
                <InlineTextButton className={`${css.askForStaffbtn} ${css.redbtn}`} disabled>
                  <FormattedMessage id="TransactionPanel.cancelled" />
                </InlineTextButton>
              </>
            ) : txLastTransition === TRANSITION_ZERO_REQUEST_PAYMENT ? (
              <>
                <span className={css.hDivider} />

                {/* when worker is not accepted */}
                <div className={css.staffBtnWrapper}>
                  <InlineTextButton
                    className={css.askForStaffbtn}
                    inProgress={acceptAppliedJobInProgress?.includes(workerDetails?.id?.uuid)}
                    onClick={e => {
                      e.stopPropagation();
                      onAcceptAppliedJob(txId, listingId, workerDetails, listingTimeslots)
                        .then(resp => {
                          if (typeof onSucessHandler === 'function') {
                            onSucessHandler();
                          }
                          const {
                            attributes: { lastTransition },
                          } = resp;
                          setTxLastTransition(lastTransition);
                        })
                        .catch(err => {});
                    }}
                  >
                    <FormattedMessage id="TransactionPanel.acceptButton" />
                  </InlineTextButton>
                  <InlineTextButton
                    className={css.declineStaffbtn}
                    inProgress={declineAppliedJobInProgress?.includes(workerDetails?.id?.uuid)}
                    onClick={e => {
                      e.stopPropagation();
                      onDeclineAppliedJob(txId, listingId, workerDetails)
                        .then(resp => {
                          if (typeof onSucessHandler === 'function') {
                            onSucessHandler();
                          }
                          const {
                            attributes: { lastTransition },
                          } = resp;
                          setTxLastTransition(lastTransition);
                        })
                        .catch(err => {});
                    }}
                  >
                    <FormattedMessage id="TransactionPanel.rejectButton" />
                  </InlineTextButton>
                </div>
              </>
            ) : txLastTransition === TRANSITION_ZERO_DECLINE_PAYMENT ? (
              <>
                <span className={css.hDivider} />
                <InlineTextButton className={css.declineStaffbtn} disabled>
                  <FormattedMessage id="InboxPage.stateDeclined" />
                </InlineTextButton>
              </>
            ) : acceptedTransactions.has(txLastTransition) ? (
              <>
                <span className={css.hDivider} />
                <InlineTextButton className={css.askForStaffbtn} disabled>
                  <FormattedMessage id="InboxPage.stateAccepted" />
                </InlineTextButton>
              </>
            ) : null
          ) : null}
        </div>
      )}
      {isWorkerTimeslotBlocked || isListingVacancyFull ? (
        <div>
          <div className={css.noApplyContainer}>
            <div className={css.appliedModalDiv}>
              <div className={css.modalTitle}>
                <FormattedMessage
                  id={
                    isWorkerTimeslotBlocked
                      ? 'WorkersCard.workerBlocked.title'
                      : 'WorkersCard.listingVacancyFull.title'
                  }
                />
                <div className={css.modalDesc}>
                  <FormattedMessage
                    id={
                      isWorkerTimeslotBlocked
                        ? 'WorkersCard.workerBlocked.desc'
                        : 'WorkersCard.listingVacancyFull.desc'
                    }
                  />
                </div>
                <InlineTextButton type="button" className={css.submitButton} onClick={closeModal}>
                  <FormattedMessage id="ContactDetailsForm.TurnOnAuth" />
                </InlineTextButton>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
}

const mapStateProps = state => {
  const {
    acceptAppliedJobInProgress,
    acceptAppliedJobSuccess,
    acceptAppliedJobError,
    gigCount,
    declineAppliedJobInProgress,
    declineAppliedJobSuccess,
    declineAppliedJobError,
    isWorkerTimeslotBlocked,
    isListingVacancyFull,
  } = state.WorkerCardPage;
  return {
    acceptAppliedJobInProgress,
    acceptAppliedJobSuccess,
    acceptAppliedJobError,
    gigCount,
    declineAppliedJobInProgress,
    declineAppliedJobSuccess,
    declineAppliedJobError,
    isWorkerTimeslotBlocked,
    isListingVacancyFull,
  };
};

const mapDispatchToProps = dispatch => ({
  onAcceptAppliedJob: (txId, listingId, workerDetails, listingTimeslots) =>
    dispatch(acceptAppliedJob(txId, listingId, workerDetails, listingTimeslots)),
  onUpdateProfile: data => dispatch(updateProfile(data)),
  onDeclineAppliedJob: (txId, listingId, workerDetails) =>
    dispatch(declineAppliedJob(txId, listingId, workerDetails)),
  onSetWorkerBlockedTimeslotStatus: payload => dispatch(setWorkerBlockedTimeslotStatus(payload)),
  onSetListingVacancyFullStatus: payload => dispatch(setListingVacancyFullStatus(payload)),
});

const WorkersCard = compose(
  injectIntl,
  connect(
    mapStateProps,
    mapDispatchToProps
  )
)(WorkersCardComponent);

export default WorkersCard;
